/* eslint-disable consistent-return */
/* eslint-disable no-plusplus */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-unreachable-loop */
/* eslint-disable react/no-unstable-nested-components */
import React, { useCallback, useEffect, useState } from 'react';
import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Stack,
  SwipeableDrawer,
  Tooltip,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import dayjs from 'dayjs';
import _ from 'lodash';
import {
  ArrowBack,
  ArrowDownward,
  CalendarTodayRounded,
  CloseRounded,
  EditRounded,
  PeopleAltRounded,
  Person,
  RefreshRounded,
  RemoveCircleOutlineRounded,
  RemoveCircleRounded,
  VpnKeyRounded,
} from '@mui/icons-material';

import TenLogo from '../../../assets/horizontal-blue-logo.svg';

import {
  CardNewAdmin,
  Companies,
  Container,
  ContainerAdminsList,
  Div,
  Header,
  HeaderEdit,
  InfoCompanies,
  Logo,
  Page,
  SectionCompanies,
  SectionDetails,
  SectionInputs,
  TabButton,
  TabSelection,
  Title,
  TitleCompany,
} from './styles';

import { Account } from '../../../services/requests/contas/types';

import {
  addAdminRequest,
  getAccountByIdRequest,
  removeAdminRequest,
  updateAccountRequest,
} from '../../../services/requests/contas/utils';
import { stringAvatar } from '../../../utils/avatarGenerator';
import {
  getNumberOfUsersRegistered,
  getUserStatus,
} from '../../../utils/nameHelpers';
import { isValidCPF } from '../../../utils/cpfValidation';

import { Company, getCompaniesByAccountIdRequest } from '../../../services';

import useAuthStore from '../../../store/auth';
import useAccountStore from '../../../store/accounts';
import useCompanyStore from '../../../store/companies';

import { CadastroEmpresa } from '../CadastroEmpresa';
import { FormCriarConta } from '../FormCriarConta';

import { Input } from '../../../components/Input';
import { CpfInput } from '../../../components/CpfInput';
import { LogoCompanies } from '../../../components/LogoCompanies';
import { InfoCard } from '../../../components/InfoCard';
import { ConfirmModal } from '../../../components/ConfirmModal';
import { LoadingBackdrop } from '../../../components/LoadingBackdrop';

dayjs().format();

export const DetalhesConta = () => {
  const params = useParams();
  const navigate = useNavigate();

  const user = useAuthStore(state => state.user);
  const setCompanies = useCompanyStore(state => state.setCompanies);
  const selectedAccount = useAccountStore(state => state.selectedAccount);
  const setSelectedAccount = useAccountStore(state => state.setSelectedAccount);

  const [conta, setConta] = useState<Account>({
    id: '',
    name: '',
    status: false,
    owner_id: '',
    companies: [],
    companies_ids: [],
    admins: [],
    admins_ids: [],
    records: 0,
  } as Account);
  const [openEdit, setOpenEdit] = useState(false);
  const [openAdminChange, setOpenAdminChange] = useState(false);
  const [openAddCompany, setOpenAddCompany] = useState(false);
  const [statusAccount, setStatusAccount] = useState('ativo');
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingText, setIsLoadingText] = useState('Carregando Informações');
  const [openModalDesactiveAccount, setOpenModalDesactiveAccount] =
    useState(false);
  const [openModalRemoveAdmin, setOpenModalRemoveAdmin] = useState(false);
  const [openModalAddAdmin, setOpenModalAddAdmin] = useState(false);
  const [listagemAdmins, setListagemAdmins] = useState<any[]>([]);
  const [listagemAdminsExists, setListagemAdminsExists] = useState<any[]>([]);
  const [statusCompany, setStatusCompany] = useState('ativas');
  const [companiesActives, setCompaniesActives] = useState<Company[]>();
  const [companiesDesactives, setCompaniesDesactives] = useState<Company[]>();
  const [hasSomeAdmin, setHasSomeAdmin] = useState(true);
  const [adminData, setAdminData] = useState({
    name: '',
    id: '',
    email: '',
    cpf: '',
  });

  const getAccount = useCallback(
    async (id: string) => {
      try {
        const response = await getAccountByIdRequest(id);

        if (response?.status === 200) {
          // console.log('Conta', response?.data);
          const admins =
            response.data.admins?.length > 0 ? [...response.data.admins] : [];

          setStatusAccount(response?.data?.status ? 'ativo' : 'desativado');
          setListagemAdmins(admins);
          setListagemAdminsExists(admins);

          setConta({
            ...response?.data,
          });
          setSelectedAccount({ ...response?.data });
          setCompanies([...response.data.companies]);
        }
      } catch (error) {
        console.log('Error getAccount', error);
      } finally {
        setLoading(false);
      }
    },
    [setCompanies, setSelectedAccount],
  );

  const getCompanies = useCallback(
    async (id: string) => {
      try {
        const response = await getCompaniesByAccountIdRequest(id);

        if (response?.status === 200) {
          const companiesDesactived = response?.data?.filter(
            (company: Company) => company?.status === false,
          );
          const companiesActived = response?.data?.filter(
            (company: Company) => company?.status,
          );

          setCompanies(response?.data);
          setCompaniesDesactives(companiesDesactived as Company[]);
          setCompaniesActives(companiesActived as Company[]);
        }
      } catch (error) {
        console.log('Error getAccount', error);
      } finally {
        setLoading(false);
      }
    },
    [setCompanies],
  );

  useEffect(() => {
    if (params?.id) {
      getAccount(params?.id);
    }
  }, [params, openEdit, openAddCompany, openAdminChange]);

  useEffect(() => {
    if (params?.id) {
      getCompanies(params?.id);
    }
  }, [params?.id, listagemAdmins]);

  const formValidation = useCallback((): any => {
    return Yup.object().shape({
      name_usuario: Yup.string().required('O nome é obrigatório.'),
      email: Yup.string()
        .email('Digite um e-mail válido')
        .required('O campo E-mail é obrigatório.'),
      cpf: Yup.string()
        .required('O campo CPF é obrigatório.')
        .min(11, 'Mínimo de 11 dígitos')
        .test('test-invalid-cpf', 'CPF inválido', cpf =>
          isValidCPF(cpf as string),
        ),
    });
  }, []);
  const { control, handleSubmit, reset, clearErrors } = useForm({
    resolver: yupResolver(formValidation()),
  });

  const handleChangeStatusAccount = useCallback(async () => {
    setIsLoadingText('Carregando Informações da Empresa');
    setIsLoading(true);
    try {
      const idConta = conta?.id as string;

      if (idConta !== '') {
        const contaEditada = {
          status: !conta.status,
        };

        const response = await updateAccountRequest(
          contaEditada,
          idConta,
          user?.id as string,
        );

        if (response?.status === 200) {
          getAccount(params?.id as string);
          setStatusAccount(response?.data?.status ? 'ativo' : 'desativado');
          setOpenModalDesactiveAccount(false);
          getCompanies(params?.id as string);
        }
      }
    } catch (error) {
      console.log('Error handleChangeStatusAccount', error);
    } finally {
      setIsLoading(false);
    }
  }, [conta?.id, conta.status, user?.id, getAccount, params?.id, getCompanies]);

  // const handleAddNewAdmin = useCallback(
  //   (formData: any) => {
  //     try {
  //       const admin = {
  //         id: null,
  //         name: formData?.name_usuario,
  //         email: formData?.email,
  //         doc: removeDotsAndTracesCPF(formData?.cpf),
  //       };

  //       const docExists = listagemAdmins?.find(e => e.doc === admin.doc);
  //       const emailExists = listagemAdmins?.find(e => e.email === admin.email);

  //       if (docExists) {
  //         toast.warning('Erro ao cadastrar, já existe um Admin com este CPF.');
  //       } else if (emailExists) {
  //         toast.warning(
  //           'Erro ao cadastrar, já existe um Admin com este e-mail.',
  //         );
  //       } else {
  //         setListagemAdmins([...listagemAdmins, { ...admin }]);
  //         reset();
  //       }
  //     } catch (err) {
  //       console.log('Error handleAddNewAdmin', err);
  //     }
  //   },
  //   [listagemAdmins, reset],
  // );

  const handleCloseDrawerAdmins = useCallback(() => {
    reset();
    clearErrors();
    setOpenAdminChange(false);
    setHasSomeAdmin(true);
  }, [clearErrors, reset]);

  // const handleRemoveAdminList = useCallback(
  //   (userEmail: string) => {
  //     const admins = listagemAdmins?.filter(e => e.email !== userEmail);
  //     setListagemAdmins([...admins]);
  //   },
  //   [listagemAdmins],
  // );

  const handleSelectedCompany = useCallback(
    (company: Partial<Company>) => {
      const companyId = company.id;

      navigate(`/home/contas/detalhes-empresa/${companyId}`, {
        state: conta?.name,
      });
    },
    [navigate, conta],
  );

  const handleRemoveAdmin = useCallback(
    async (adminId: string, adminEmail: string) => {
      try {
        const response = await removeAdminRequest(
          params?.id as string,
          adminId,
        );

        if (response?.status === 200) {
          const adminRemoved = listagemAdmins?.filter(
            adm => adm.email !== adminEmail,
          );
          setListagemAdmins(adminRemoved);
          setOpenAdminChange(false);
          setOpenModalRemoveAdmin(false);
          setAdminData({ id: '', email: '', cpf: '', name: '' });
          toast.success('Administrador removido com sucesso!');
        }
      } catch (err) {
        console.log(err);
      }
    },
    [listagemAdmins, params?.id],
  );

  const handleValidateAdminToAdd = useCallback(
    async (formData: any) => {
      try {
        const { name_usuario, email, cpf } = formData;
        setAdminData({ id: '', cpf, email, name: name_usuario });
        const docExists = listagemAdmins?.find(e => e.doc === cpf);
        const emailExists = listagemAdmins?.find(e => e.email === email);

        if (docExists) {
          toast.warning('Erro ao cadastrar, já existe um Admin com este CPF.');
        } else if (emailExists) {
          toast.warning(
            'Erro ao cadastrar, já existe um Admin com este e-mail.',
          );
        } else {
          setOpenModalAddAdmin(true);
        }
      } catch (err) {
        console.log(err);
      }
    },
    [listagemAdmins],
  );

  const handleAddAdmin = useCallback(async () => {
    setIsLoading(true);
    try {
      const { name, email, cpf } = adminData;
      const response = await addAdminRequest(
        params?.id as string,
        name,
        email,
        cpf,
        user?.id as string,
      );

      if (response?.status === 200) {
        const newAdmin = {
          name,
          doc: cpf,
          email,
        };

        setListagemAdmins([...listagemAdmins, newAdmin]);
        reset();
        clearErrors();
        setOpenAdminChange(false);
        setOpenModalAddAdmin(false);
        setAdminData({ id: '', email: '', cpf: '', name: '' });
        toast.success('Administrador adicionado na conta!');
      }
    } catch (error) {
      console.log('Error handleAddAdmin', error);
      toast.error('Verifique as informações fornecidas');
    } finally {
      setIsLoading(false);
    }
  }, [adminData, clearErrors, listagemAdmins, params?.id, reset, user?.id]);

  useEffect(() => {
    if (listagemAdmins || listagemAdminsExists) {
      const hasSomeUserAdd = _.difference(
        listagemAdmins,
        listagemAdminsExists,
        'doc',
      );

      const hasSomeUserRemoved = _.difference(
        listagemAdminsExists,
        listagemAdmins,
        'doc',
      );

      if (hasSomeUserAdd.length > 0 || hasSomeUserRemoved.length > 0) {
        setHasSomeAdmin(false);
      }
    }
  }, [listagemAdmins, listagemAdminsExists]);

  const editDados = () => (
    <Box width="480px" margin="20px">
      <HeaderEdit>
        <IconButton onClick={() => setOpenEdit(false)}>
          <CloseRounded />
        </IconButton>
        <Box className="edit-dados">Editar Dados</Box>
      </HeaderEdit>
      <Page>
        <FormCriarConta
          accountId={conta?.id}
          accountName={conta?.name}
          handleReset={() => setOpenEdit(false)}
          setConta={setConta}
          conta={conta}
          setIsLoading={setIsLoading}
          setIsLoadingText={setIsLoadingText}
        />
      </Page>
    </Box>
  );

  const handleOpenModalRemoveAdmin = (id: string, email: string) => {
    setOpenModalRemoveAdmin(true);
    setAdminData({ id, email, cpf: '', name: '' });
  };

  const admAccount = () => (
    <Box width="480px" margin="20px">
      <HeaderEdit>
        <IconButton onClick={() => setOpenAdminChange(false)}>
          <CloseRounded />
        </IconButton>
        <Box className="change-adm">Gerenciar Admin da Conta</Box>
      </HeaderEdit>
      <Page>
        <Box className="title-admin" marginBottom="20px">
          Adicionar novo usuário como Admin da conta
        </Box>
        <form onSubmit={handleSubmit(handleValidateAdminToAdd)}>
          <SectionInputs>
            <Input
              name="email"
              control={control}
              fullWidth
              placeholder="E-mail do usuário"
            />
            <Input
              name="name_usuario"
              control={control}
              fullWidth
              placeholder="Nome do usuário"
            />
            <Input
              fullWidth
              id="outlined-basic"
              name="cpf"
              placeholder="CPF do usuário"
              control={control}
              InputProps={{ inputComponent: CpfInput as any }}
            />
            <Button
              variant="contained"
              className="btn-add-usuario"
              type="submit"
            >
              Adicionar Usuário <ArrowDownward />
            </Button>
          </SectionInputs>
          <ConfirmModal
            btnTextCancel="Cancelar"
            btnTextConfirm="Confirmar"
            onCancel={() => setOpenModalAddAdmin(false)}
            onClose={() => setOpenModalAddAdmin(false)}
            onConfirm={handleAddAdmin}
            open={openModalAddAdmin}
            title="Adicionar admin da conta"
            subtitle="Ao clicar em confirmar, o sistema enviará um e-mail de notificação para o usuário e ele terá acesso ao controle desta conta."
            type="success"
          />
        </form>
        {listagemAdmins && listagemAdmins?.length > 0 ? (
          <Box display="flex" alignItems="center" marginTop="20px">
            <Header justifyContent="start">
              <Box className="text-add-admin">Admin da Conta</Box>
            </Header>
            <Header justifyContent="end">
              <Box className="text-add-admin" sx={{ marginRight: '5px' }}>
                Status
              </Box>
              <Box className="text-add-admin">Remover</Box>
            </Header>
          </Box>
        ) : (
          <Box sx={{ marginTop: '20px' }}>
            Nenhum usuário adicionado como Admin.
          </Box>
        )}
        <ContainerAdminsList>
          {listagemAdmins &&
            listagemAdmins?.map(e => (
              <CardNewAdmin key={e.email}>
                <Header justifyContent="start">
                  {e?.avatar_url ? (
                    <Avatar sx={{ width: '40px' }}>
                      <img
                        src={e?.avatar_url as string}
                        alt="Foto de perfil"
                        style={{ width: '100%' }}
                      />
                    </Avatar>
                  ) : (
                    <Avatar {...stringAvatar(e.name!)} sx={{ width: '40px' }} />
                  )}
                  <Box className="name-admin">{e.name}</Box>
                </Header>
                <Header justifyContent="end">
                  <Box sx={{ color: e.status === 'US1' ? '#3B873E' : '#000' }}>
                    {getUserStatus(e.status!)}
                  </Box>
                  <IconButton sx={{ marginRight: '5px' }}>
                    <RemoveCircleOutlineRounded
                      color="error"
                      onClick={() => handleOpenModalRemoveAdmin(e.id, e.email)}
                      sx={{ width: '24px', height: '24px' }}
                    />
                  </IconButton>
                </Header>
              </CardNewAdmin>
            ))}
        </ContainerAdminsList>
        <ConfirmModal
          btnTextCancel="Cancelar"
          btnTextConfirm="Confirmar"
          onCancel={() => setOpenModalRemoveAdmin(false)}
          onClose={() => setOpenModalRemoveAdmin(false)}
          onConfirm={() => handleRemoveAdmin(adminData.id, adminData.email)}
          open={openModalRemoveAdmin}
          title="Remover usuário da conta"
          subtitle="Deseja realmente remover a permissão deste usuário na conta?"
          type="error"
        />
      </Page>
    </Box>
  );

  const handleUsersLength = useCallback((usersQuantity: number) => {
    if (usersQuantity > 1) {
      return `${usersQuantity} usuários`;
    }
    return `${usersQuantity} usuário`;
  }, []);

  if (loading) {
    return (
      <Container display="flex" justifyContent="center" alignItems="center">
        <CircularProgress />
      </Container>
    );
  }

  return (
    <Container>
      {isLoading && (
        <LoadingBackdrop
          component=""
          loading={isLoading}
          text={isLoadingText}
        />
      )}
      <Header>
        <Button
          className="btn-back"
          variant="outlined"
          onClick={() => navigate(-1)}
        >
          <ArrowBack /> Voltar
        </Button>
        <Title>{selectedAccount?.name}</Title>
      </Header>
      <SectionDetails>
        <Div>
          <Box width="60vw">
            <Tooltip title={selectedAccount?.name}>
              <Box
                color={statusAccount === 'ativo' ? 'black' : '#d62237'}
                className="title-details"
              >
                {selectedAccount?.name}
              </Box>
            </Tooltip>
          </Box>
          {statusAccount === 'ativo' && (
            <React.Fragment key="right">
              <Button
                variant="contained"
                className="btn-edit"
                onClick={() => setOpenEdit(true)}
              >
                <EditRounded /> Editar Dados
              </Button>
            </React.Fragment>
          )}
          {statusAccount === 'desativado' && (
            <Button
              variant="contained"
              color="error"
              className="btn-adm"
              onClick={() => setOpenModalDesactiveAccount(true)}
            >
              <RefreshRounded /> Reativar Conta
            </Button>
          )}
          <SwipeableDrawer
            anchor="right"
            open={openEdit}
            onClose={() => setOpenEdit(false)}
            onOpen={() => setOpenEdit(true)}
            ModalProps={{
              keepMounted: true,
            }}
          >
            {editDados()}
          </SwipeableDrawer>
        </Div>
        <Div>
          <Box className="item-text">
            <VpnKeyRounded /> ID da Conta: {conta?.id}
          </Box>
          {statusAccount === 'ativo' && (
            <React.Fragment key="right">
              <Button
                variant="outlined"
                className="btn-adm"
                onClick={() => setOpenAdminChange(true)}
              >
                <PeopleAltRounded /> Admin da Conta
              </Button>
            </React.Fragment>
          )}
          <SwipeableDrawer
            anchor="right"
            open={openAdminChange}
            onClose={handleCloseDrawerAdmins}
            onOpen={() => setOpenAdminChange(true)}
            ModalProps={{
              keepMounted: true,
            }}
          >
            {admAccount()}
          </SwipeableDrawer>
        </Div>
        <Div>
          <Box className="item-text">
            <CalendarTodayRounded /> Cadastrada em{' '}
            {dayjs(conta?.created_at).format('DD/MM/YYYY HH:mm')}
          </Box>
          {statusAccount === 'ativo' && (
            <Button
              variant="outlined"
              color="error"
              className="btn-adm"
              onClick={() => setOpenModalDesactiveAccount(true)}
            >
              <RemoveCircleRounded /> Desativar Conta
            </Button>
          )}
          <Dialog
            open={openModalDesactiveAccount}
            onClose={() => setOpenModalDesactiveAccount(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            id="dialog-main"
          >
            <DialogTitle id="alert-dialog-title">
              {statusAccount === 'ativo' ? 'Desativar conta' : 'Ativar conta'}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {statusAccount === 'ativo'
                  ? 'Ao desativar a conta, todas empresas e usuários vinculados perderão acesso. Deseja continuar?'
                  : 'Ao ativar a conta, todas empresas e usuários vinculados terão acesso novamente. Deseja continuar?'}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => setOpenModalDesactiveAccount(false)}
                variant="text"
                sx={{ color: '#9E9E9E' }}
              >
                Cancelar
              </Button>
              <Button
                onClick={handleChangeStatusAccount}
                autoFocus
                color={statusAccount === 'ativo' ? 'error' : 'success'}
                variant="contained"
                sx={{ color: '#fff' }}
              >
                Confirmar
              </Button>
            </DialogActions>
          </Dialog>
        </Div>
        <Div>
          <Box className="item-text">
            <Person /> {getNumberOfUsersRegistered(conta?.total ?? 0)} na conta
          </Box>
        </Div>
        <Box display="flex" flexDirection="column" gap="10px" marginTop="20px">
          <Box className="adm">Admin da conta:</Box>
          <Stack direction="row" spacing={2}>
            {conta?.admins?.map(a => (
              <Tooltip key={a.id} title={a.name!} placement="bottom">
                {a?.avatar_url ? (
                  <Avatar sx={{ width: '40px' }}>
                    <img
                      src={a?.avatar_url as string}
                      alt="Foto de perfil"
                      style={{ width: '100%' }}
                    />
                  </Avatar>
                ) : (
                  <Avatar
                    {...stringAvatar(`${a?.name}` || 'Ten Meetings')}
                    sx={{ width: '40px' }}
                  />
                )}
              </Tooltip>
            ))}
          </Stack>
        </Box>
      </SectionDetails>
      <SectionDetails>
        <Div>
          <Title>Empresas da Conta</Title>
          <React.Fragment key="right">
            {statusAccount === 'ativo' && (
              <Button
                variant="contained"
                className="btn-add-companie"
                onClick={() => setOpenAddCompany(true)}
              >
                adicionar empresa
              </Button>
            )}
          </React.Fragment>
          <SwipeableDrawer
            anchor="right"
            open={openAddCompany}
            onClose={() => setOpenAddCompany(false)}
            onOpen={() => setOpenAddCompany(true)}
            ModalProps={{
              keepMounted: true,
            }}
          >
            <CadastroEmpresa
              getCompanies={() => getCompanies(params?.id as string)}
              handleReset={() => setOpenAddCompany(false)}
              accountId={params?.id as string}
              conta={conta}
              setIsLoading={setIsLoading}
              setIsLoadingText={setIsLoadingText}
            />
          </SwipeableDrawer>
        </Div>
        <TabSelection>
          <TabButton
            active={statusCompany === 'ativas'}
            onClick={() => setStatusCompany('ativas')}
          >
            Ativas
          </TabButton>
          <TabButton
            active={statusCompany === 'desativadas'}
            onClick={() => setStatusCompany('desativadas')}
          >
            Desativadas
          </TabButton>
        </TabSelection>
        <SectionCompanies marginTop="20px">
          {statusCompany === 'ativas' ? (
            companiesActives && companiesActives?.length > 0 ? (
              companiesActives?.map((empresa: Partial<Company>) => (
                <Companies
                  key={empresa?.id}
                  onClick={() => handleSelectedCompany(empresa)}
                >
                  <Logo>
                    <LogoCompanies
                      url={empresa?.logo_url ? empresa?.logo_url : TenLogo}
                      height="100%"
                      boxWidth="100%"
                      maxWidth="100%"
                      width=""
                      justifyContent="start"
                    />
                  </Logo>
                  <InfoCompanies>
                    <Box
                      className={
                        empresa?.status ? 'status-ativo' : 'status-desativado'
                      }
                    >
                      {empresa?.status ? 'Ativo' : 'Desativado'}
                    </Box>
                    <Tooltip title={empresa?.name}>
                      <TitleCompany>
                        {empresa?.fancy_name ?? empresa?.name}
                      </TitleCompany>
                    </Tooltip>
                    <Box className="companyLength">
                      {handleUsersLength(empresa?.users_ids?.length || 0)}
                    </Box>
                  </InfoCompanies>
                </Companies>
              ))
            ) : (
              <Box
                width="100%"
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <InfoCard title="Nenhuma empresa encontrada" type="info" />
              </Box>
            )
          ) : companiesDesactives && companiesDesactives?.length > 0 ? (
            companiesDesactives?.map(empresa => (
              <Companies
                key={empresa?.id}
                onClick={() => handleSelectedCompany(empresa)}
              >
                <Logo>
                  <LogoCompanies
                    url={empresa?.logo_url ? empresa?.logo_url : TenLogo}
                    boxWidth="100%"
                    height="100%"
                    maxWidth="100%"
                    width=""
                    justifyContent="start"
                  />
                </Logo>
                <InfoCompanies>
                  <Box
                    className={
                      empresa?.status ? 'status-ativo' : 'status-desativado'
                    }
                  >
                    {empresa?.status ? 'Ativo' : 'Desativado'}
                  </Box>
                  <Tooltip title={empresa?.name}>
                    <TitleCompany>
                      {empresa?.fancy_name ?? empresa?.name}
                    </TitleCompany>
                  </Tooltip>
                  <Box className="companyLength">
                    {handleUsersLength(empresa?.users_ids?.length || 0)}
                  </Box>
                </InfoCompanies>
              </Companies>
            ))
          ) : (
            <Box
              width="100%"
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <InfoCard title="Nenhuma empresa encontrada" type="info" />
            </Box>
          )}
        </SectionCompanies>
      </SectionDetails>
    </Container>
  );
};
